import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";

const Home = () => {

  const { changeBackground } = useContext(ThemeContext);

  const [appointments, setAppointments] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    changeBackground({ value: "light", label: "Light" });

    fetchAppointments();
    fetchGallery();
    fetchTestimonials();
    fetchBlogs();

  }, []);

  // ================= FETCH APPOINTMENTS =================
  const fetchAppointments = async () => {
    try {
      const res = await fetch("https://admin.drgargevascular.com/backend/appointments");
      const data = await res.json();
      setAppointments(data);
    } catch (error) {
      console.log(error);
    }
  };

  // ================= FETCH GALLERY =================
  const fetchGallery = async () => {
    try {
      const res = await fetch("https://admin.drgargevascular.com/backend/gallery");
      const data = await res.json();
      setGallery(data);
    } catch (error) {
      console.log(error);
    }
  };

  // ================= FETCH TESTIMONIALS =================
  const fetchTestimonials = async () => {
    try {
      const res = await fetch("https://admin.drgargevascular.com/backend/testimonials");
      const data = await res.json();
      setTestimonials(data);
    } catch (error) {
      console.log(error);
    }
  };

  // ================= FETCH BLOGS =================
  const fetchBlogs = async () => {
    try {
      const res = await fetch("https://admin.drgargevascular.com/backend/blogs");
      const data = await res.json();
      setBlogs(data);
    } catch (error) {
      console.log(error);
    }
  };

  // ================= DASHBOARD CARDS =================
  const dashboardCards = [
    {
      title: "Appointments",
      icon: "flaticon-381-calendar-1",
      count: appointments.length,
      link: "/appointments",
      color: "bg-primary",
    },
    {
      title: "Blogs",
      icon: "flaticon-381-notepad",
      count: blogs.length,
      link: "/blogs",
      color: "bg-success",
    },
    {
      title: "Testimonials",
      icon: "flaticon-381-user-7",
      count: testimonials.length,
      link: "/testimonials",
      color: "bg-warning",
    },
    {
      title: "Gallery Images",
      icon: "flaticon-381-photo",
      count: gallery.length,
      link: "/gallery",
      color: "bg-danger",
    },
  ];

  return (
    <>
      <div className="form-head d-flex mb-4 align-items-center justify-content-between">
        <div>
          <h3 className="text-primary font-w600">
            Welcome to Admin Dashboard
          </h3>
          <p className="mb-0">
            Manage appointments, blogs, testimonials and images
          </p>
        </div>
      </div>

      {/* ================= CARDS ================= */}
      <div className="row">
        {dashboardCards.map((item, index) => (
          <div className="col-xl-3 col-lg-6 col-sm-6" key={index}>
            <div className={`card ${item.color}`}>
              <div className="card-body p-4">

                <div className="media align-items-center">
                  <span className="me-3 text-white">
                    <i className={item.icon} style={{ fontSize: "30px" }}></i>
                  </span>

                  <div className="media-body text-end text-white">
                    <p className="mb-1">{item.title}</p>
                    <h2 className="text-white">{item.count}</h2>
                  </div>
                </div>

                <div className="mt-3 text-end">
                  <Link to={item.link} className="btn btn-light btn-sm">
                    Manage
                  </Link>
                </div>

              </div>
            </div>
          </div>
        ))}
      </div>

      {/* ================= CONTENT ================= */}
      <div className="row mt-4">

        {/* ================= APPOINTMENTS ================= */}
        <div className="col-xl-4">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Recent Appointments</h4>
            </div>

            <div className="card-body">
              {appointments.length === 0 ? (
                <p>No appointments available.</p>
              ) : (
                <ul className="list-group">
                  {appointments.slice(0,5).map((item) => (
                    <li key={item.id} className="list-group-item d-flex justify-content-between">
                      <div>
                        <strong>{item.full_name}</strong>
                        <br />
                        {item.services}
                      </div>
                      <div className="text-end">
                        {item.date}
                        <br />
                        {item.time}
                      </div>
                    </li>
                  ))}
                </ul>
              )}
              <Link to="/appointments" className="btn btn-primary mt-3">
                View All
              </Link>
            </div>
          </div>
        </div>

        {/* ================= TESTIMONIALS ================= */}
        <div className="col-xl-4">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Recent Testimonials</h4>
            </div>

            <div className="card-body">
              {testimonials.length === 0 ? (
                <p>No testimonials available.</p>
              ) : (
                <ul className="list-group">
                  {testimonials.slice(0,5).map((item) => (
                    <li key={item.id} className="list-group-item">
                      <strong>{item.name}</strong>
                      <br />
                      <small>{item.role}</small>
                      <p style={{ fontSize: "13px", marginTop: "5px" }}>
                        {item.message.substring(0, 60)}...
                      </p>
                    </li>
                  ))}
                </ul>
              )}
              <Link to="/testimonials" className="btn btn-warning mt-3">
                Manage
              </Link>
            </div>
          </div>
        </div>

        {/* ================= BLOGS ================= */}
        <div className="col-xl-4">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Recent Blogs</h4>
            </div>

            <div className="card-body">

              {blogs.length === 0 ? (
                <p>No blogs available.</p>
              ) : (
                <div>
                  {blogs.slice(0,3).map((item) => (
                    <div key={item.id} style={{
                      display: "flex",
                      gap: "10px",
                      marginBottom: "12px",
                      borderBottom: "1px solid #eee",
                      paddingBottom: "10px"
                    }}>

                      <img
                        src={`https://admin.drgargevascular.com/backend${item.image}`}
                        alt=""
                        style={{
                          width: "80px",
                          height: "60px",
                          objectFit: "cover",
                          borderRadius: "6px"
                        }}
                      />

                      <div>
                        <strong style={{ fontSize: "14px" }}>
                          {item.title}
                        </strong>

                        <p style={{
                          fontSize: "12px",
                          margin: "5px 0",
                          color: "#666"
                        }}>
                          {item.content?.substring(0, 50)}...
                        </p>
                      </div>

                    </div>
                  ))}
                </div>
              )}

              <Link to="/blogs" className="btn btn-success mt-3">
                Manage
              </Link>

            </div>
          </div>
        </div>

      </div>

      {/* ================= GALLERY ================= */}
      <div className="row mt-4">
        <div className="col-xl-12">
          <div className="card">

            <div className="card-header">
              <h4 className="card-title">Recent Gallery</h4>
            </div>

            <div className="card-body">

              {gallery.length === 0 ? (
                <p>No images uploaded.</p>
              ) : (
                <div className="row">
                  {gallery.slice(0,8).map((item) => (
                    <div key={item.id} className="col-lg-3 col-md-4 col-6 mb-3">
                      <img
                        src={`https://admin.drgargevascular.com/backend${item.image_url}`}
                        alt={item.title}
                        style={{
                          width: "100%",
                          height: "120px",
                          objectFit: "cover",
                          borderRadius: "8px"
                        }}
                      />
                    </div>
                  ))}
                </div>
              )}

              <Link to="/gallery" className="btn btn-danger mt-3">
                Manage
              </Link>

            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default Home;